import styled from 'styled-components';

export const Separator = styled.div.attrs({ children: '* * *' })`
  text-align: center;
  margin: 1.8em 0;
`;
